import { NavLink } from "react-router";
import React from "react";
import styled from "styled-components";
import { INavLink } from "core-integration/src/hooks/types";
import "./ListItem.css";

const LIStyled = styled.li`
  list-style-type: none;
  display: inline-block;
  margin: 0 8px 0 0;
  border-radius: 40px;
  background: ${({ theme }) => theme.colors.purple1};

  &:last-child a {
    border: 0;
  }
  &:hover {
    background: ${({ theme }) => theme.colors.purple2};
    border-radius: 6px;
  }
  &:hover a {
    color: ${({ theme }) => theme.colors.purple1};
  }
`;

const ListItem = React.forwardRef<HTMLLIElement, INavLink>(
  ({ useRouter, text, href, rel, target }, ref) => {
    return (
      <LIStyled ref={ref}>
        {useRouter ? (
          <NavLink
            to={href}
            className={({ isActive }) =>
              isActive ? `ism-nav__tab active` : `ism-nav__tab`
            }
          >
            {text}
          </NavLink>
        ) : (
          <a href={href} className="ism-nav__tab" rel={rel} target={target}>
            <span>{text}</span>
          </a>
        )}
      </LIStyled>
    );
  },
);

export default ListItem;
